module.exports = __webpack_public_path__ + "assets/img/star_sentence_select5.524ff9a3.png";